import React from 'react';
const SupplierCard = (props) => {
    return(
        <div onClick={()=>window.location.href=props.details[0]}>
            <div className=" supplier-dashboard-box">
                <div>
                    <div >{props.details[1]}</div>
                </div>
                <h6 className="namings">{props.details[2]}</h6>
            </div>
        </div>
    );
};

export default SupplierCard;